export const helpingVerbs = ["is", "was", "are", "were"];

export const possessivePronouns = ["his", "her", "theirs", "ours", "its"];

export const prepositions = ["above", "across", "at", "after", "against", "about", "aboard", "along",
														"around", "from", "on", "among", "as", "away", "before", "behind",
														"between", "by", "ahead", "amid", "below", "apart", "down", "up"];

export const misc = ["and", "the", "do"];